
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from 'components/Icon'

export default class Limit extends React.Component {
  static propTypes = {
    action: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    limitKey: PropTypes.string,
    className: PropTypes.string,
    bigIcon: PropTypes.bool,
    inline: PropTypes.bool
  }

  static defaultProps = {
    action: 'read'
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {children, limitKey, action} = this.props
    const {permissions} = this.context

    if (!limitKey || (permissions[action] && permissions[action].includes(`@features/${limitKey}`))) {
      return children
    }

    return this.renderLimit()
  }

  renderLimit() {
    const {children, bigIcon, inline, className} = this.props

    const classNames = classnames('limit', className, {
      'is-icon-big': bigIcon,
      'is-inline': inline
    })
    return (
      <div className={classNames}>
        {this.renderMessage()}
        {children}
        <Icon
          className='limit_icon'
          name={bigIcon ? 'trial-medium' : 'trial'}
          size={bigIcon ? '27px' : '16px'}
        />
      </div>
    )
  }

  renderMessage() {
    const {message} = this.props

    if (!message) return null

    return (
      <div className='limit_message'>
        {message}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/containers/Limit/index.js